type Props = {
  valor: number;
  visible: boolean;
  onClick: () => void;
  selectionLabel: string;
};

function fmt(v: number) {
  return v.toFixed(2).replace('.', ',');
}

export default function StickyCTABar({ valor, visible, onClick, selectionLabel }: Props) {
  return (
    <div className={`mz-stkb ${visible ? '' : 'mz-stkb-hidden'}`} role="region" aria-label="Liberar música">
      <div className="mz-stkb-inner">
        <div className="mz-stkb-summary">
          <div className="mz-stkb-eyebrow">{selectionLabel}</div>
          <div className="mz-stkb-price">R$ {fmt(valor)}</div>
        </div>
        <button type="button" onClick={onClick} className="mz-stkb-btn">
          <span>Liberar minha música</span>
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>

      <style>{`
        .mz-stkb {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 60;
          padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
          background:
            linear-gradient(180deg, rgba(255,250,244,0) 0%, rgba(255,250,244,0.92) 30%, rgba(255,250,244,0.98) 100%);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          transform: translateY(0);
          transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s;
          will-change: transform;
          pointer-events: auto;
        }

        html[data-theme='dark'] .mz-stkb {
          background:
            linear-gradient(180deg, rgba(20,10,28,0) 0%, rgba(20,10,28,0.85) 30%, rgba(20,10,28,0.98) 100%);
        }

        .mz-stkb-hidden {
          transform: translateY(120%);
          pointer-events: none;
          opacity: 0;
        }

        .mz-stkb-inner {
          display: flex;
          align-items: center;
          gap: 12px;
          max-width: 660px;
          margin: 0 auto;
          padding: 10px 12px;
          background: #fff;
          border-radius: 999px;
          border: 1.5px solid var(--gold-border);
          box-shadow:
            0 16px 38px -10px rgba(204,102,32,0.42),
            0 0 0 1px rgba(255,145,77,0.10);
        }
        html[data-theme='dark'] .mz-stkb-inner {
          background: rgba(40,28,14,0.95);
          border-color: rgba(255,145,77,0.30);
        }

        .mz-stkb-summary {
          flex: 1;
          min-width: 0;
          padding: 0 6px 0 14px;
        }

        .mz-stkb-eyebrow {
          font-family: 'DM Sans', sans-serif;
          font-size: 10px;
          font-weight: 700;
          color: var(--text-muted);
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .mz-stkb-price {
          font-family: 'DM Sans', sans-serif;
          font-size: 22px;
          font-weight: 800;
          color: var(--amber-deep);
          letter-spacing: -0.025em;
          line-height: 1;
          font-variant-numeric: tabular-nums;
        }
        html[data-theme='dark'] .mz-stkb-price { color: var(--gold-light); }

        .mz-stkb-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 16px 22px;
          background: linear-gradient(135deg, var(--gold) 0%, var(--gold-hover) 100%);
          color: #fff;
          border: none;
          border-radius: 999px;
          font-family: 'DM Sans', sans-serif;
          font-size: 15.5px;
          font-weight: 800;
          letter-spacing: -0.005em;
          cursor: pointer;
          box-shadow: 0 6px 18px rgba(255,145,77,0.55), inset 0 -2px 4px rgba(0,0,0,0.16);
          transition: transform 0.18s, box-shadow 0.18s;
          white-space: nowrap;
          flex-shrink: 0;
        }
        .mz-stkb-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 24px rgba(255,145,77,0.65); }
        .mz-stkb-btn:active { transform: translateY(0) scale(0.97); }
        .mz-stkb-btn:focus-visible {
          outline: 3px solid var(--gold-pale);
          outline-offset: 2px;
        }

        @media (max-width: 360px) {
          .mz-stkb-btn span { font-size: 14px; }
          .mz-stkb-btn { padding: 14px 16px; }
          .mz-stkb-price { font-size: 19px; }
        }
      `}</style>
    </div>
  );
}
